export default [
    {
        value:"",
        label:"no_filter",
    },
    {
        value: 'regex',
        label: 'regular_phrase'
    },
    {
        value: 'list',
        label:'list'
    },
    {
        value:"not_in_list",
        label:"not_in_list",
    },
    {
        value: 'contains',
        label:'contains'
    },
    {
        value: 'not_contains',
        label:'not_contains'
    },
    {
        value: 'max_length',
        label:'max_length'
    },
    {
        value: 'min_length',
        label:'min_length'
    },
    {
        value: 'between',
        label:'between'
    },
    {
        value: 'start_by',
        label:'start_by'
    },
    {
        value: 'not_start_by',
        label:'not_start_by'
    },
    {
        value: 'age',
        label:'age'
    }

]